import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {
  @Input() isPage = false;

  private show = false;
  constructor() { }

  ngOnInit(): void {
  }

  public showLoader(): void {
    this.show = true;
  }

  public hideLoader(): void {
    this.show = false;
  }

}
